export default __webpack_public_path__ + "static/rajDavid-09ae8822d1fad2758d4bd1488fb0fe8a.png";